import React, { useRef, useState, useEffect } from 'react';

const REDUCED =
  typeof window !== 'undefined' && window.matchMedia &&
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const CHIPS = [
  'a garden alone',
  "a home's interiors",
  'interiors + architecture',
  'landscape + interiors',
  'architecture-led',
  'an estate masterplan',
  'everything together',
];

const PracticeSevenWays = () => {
  const ref = useRef(null);
  const [inView, setInView] = useState(!!REDUCED);
  useEffect(() => {
    if (REDUCED) return undefined;
    const el = ref.current;
    if (!el) return undefined;
    const io = new IntersectionObserver((es) => {
      es.forEach((e) => { if (e.isIntersecting) { setInView(true); io.disconnect(); } });
    }, { threshold: 0.2 });
    io.observe(el);
    return () => io.disconnect();
  }, []);

  return (
    <section ref={ref} style={{ background: '#F8F8F7', padding: '160px 0' }} data-testid="practice-sevenways-section">
      <style>{`
        .sw-rev{ opacity:0; transform:translateY(18px); transition:opacity .7s cubic-bezier(.2,.8,.2,1), transform .7s cubic-bezier(.2,.8,.2,1); }
        .sw-rev.in{ opacity:1; transform:none; }
        .sw-chip{ display:inline-block; font-family:Inter, sans-serif; font-size:15px; padding:18px 28px; border:1.5px solid #002F6C; color:#002F6C; background:transparent; line-height:1; white-space:nowrap; transition:background .25s ease, color .25s ease, transform .25s ease, opacity .6s ease; }
        .sw-ghost{ right:44px; }
        .sw-ord{ display:block; font-family:Inter, sans-serif; font-size:9.5px; letter-spacing:.2em; opacity:.55; margin-bottom:5px; color:inherit; }
        .sw-chip:hover{ background:#002F6C; color:#fff; transform:translateY(-3px); }
        @media (max-width:760px){ .sw-chip{ white-space:normal; } }
        @media (prefers-reduced-motion: reduce){ .sw-rev{ opacity:1; transform:none; transition:none; } .sw-chip{ transition:background .25s ease, color .25s ease, transform .25s ease; } }
      `}</style>

      <div className="pr-spine" style={{ position: 'relative' }}>
        <p className={`sw-rev${inView ? ' in' : ''}`}
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: '11.5px', letterSpacing: '0.3em', color: '#4A6A9C', textTransform: 'lowercase' }}
          data-testid="practice-sevenways-kicker">
          how we work
        </p>

        <h2 className={`sw-rev${inView ? ' in' : ''}`}
          style={{ fontFamily: 'Inter, sans-serif', fontWeight: 600, fontSize: 'clamp(34px,5vw,64px)', lineHeight: 1.06, color: '#002F6C', letterSpacing: '-0.03em', marginTop: 18, transitionDelay: '80ms' }}
          data-testid="practice-sevenways-heading">
          no two briefs are alike.<br />so we work in seven ways.
        </h2>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16, marginTop: 52, maxWidth: 920 }} data-testid="practice-sevenways-chips">
          {CHIPS.map((c, i) => (
            <span key={i} className={`sw-chip sw-rev${inView ? ' in' : ''}`} style={{ transitionDelay: `${i * 60}ms` }} data-testid={`practice-chip-${i}`}>
              <span className="sw-ord" data-testid={`practice-chip-ord-${i}`}>{String(i + 1).padStart(2, '0')}</span>
              {c}
            </span>
          ))}
        </div>

        <p className={`sw-rev${inView ? ' in' : ''}`}
          style={{ fontFamily: 'Lato, sans-serif', fontWeight: 300, fontSize: '18px', lineHeight: 1.7, maxWidth: 540, marginTop: 44, color: '#3A3530', transitionDelay: '120ms' }}
          data-testid="practice-sevenways-lede">
          whichever way you choose, the engagement follows the same seven-stage structure, benchmarked against national and international frameworks. it starts with a conversation.
        </p>

        <span className="pr-ghost sw-ghost" aria-hidden="true" data-testid="practice-ghost-07">07</span>
      </div>
    </section>
  );
};

export default PracticeSevenWays;
